import React, { useState, useEffect } from 'react';
import { UseGetRequest } from '../../Utils/api/ApiRequests';
import { useNavigate } from 'react-router-dom';
import { Layout, Row, Col, Card, Typography, Space, Button, Menu, Dropdown } from 'antd';
import { Person, ShowChart, PaymentsOutlined, CreditCardOffOutlined } from '@mui/icons-material';
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, LineChart, Line, ResponsiveContainer } from 'recharts';
import Navbar from '../../Components/Navbar/Navbar';
import backgroundImage from '../../Assets/Images/dashboard_card_img.png';
import { formatAmount, formatDateTime, getFullName, getUserRole } from '../../Utils/Common';

const Dashboard = () => {
  const role_name = getUserRole();
  const [dashboardData, setDashboardData] = useState(null);
  const [propertyData, setPropertyData] = useState(null);
  const [revenueData, setRevenueData] = useState(null);
  const [meterData, setMeterData] = useState(null);
  const [rentalUnits, setRentalUnits] = useState([]);

  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    // Clear the interval when the component unmounts or when the dependency array changes
    return () => clearInterval(intervalId);
  }, []);

  const fetchData = async () => {
    const response = await UseGetRequest("dashboard/get_without_filter", {});
    if(response.data){
      setDashboardData(response.data);
    } else {
      setDashboardData({})
    }
  };

  const fetchPropertyData = async () => {
    const response = await UseGetRequest("dashboard/get_property_insights", {});
    if(response.data){
      setPropertyData(response.data);
    } else {
      setPropertyData({})
    }
  };

  const fetchRentalUnits = async () => {
    const response = await UseGetRequest("rental_units/get", {});
    if(response.data){
      setRentalUnits(response.data.data);
    } else {
      setRentalUnits([])
    }
  };
  const fetchRevenueData = async () => {
    const response = await UseGetRequest("dashboard/get_revenue_overview", {});
    if(response.data){
      setRevenueData(response.data);
    } else {
      setRevenueData({})
    }
  };

  const fetchMeterData = async () => {
    const response = await UseGetRequest("dashboard/get_meter_readings", {});
    if(response.data){
      setMeterData(response.data);
    } else {
      setMeterData({})
    }
  };

  useEffect(() => {
    fetchMeterData();
    fetchRevenueData();
    fetchRentalUnits();
    fetchPropertyData();
    fetchData();
  }, []);
  return (
    <Layout className='page'>
      <Navbar navKey={'dashboard_nav'}/>
      <Layout className='dashboard-page'>
        <Row className='custom-padding responsive-tab-inline'>
            <Col span={12} className='header-container-two resp-header' style={{fontSize:'2rem'}}>
              <Person/> Hi! Welcome, {getFullName()}
            </Col>
            <Col span={12} className='header-container-date resp-header' align="right">
              {formatDateTime(currentDateTime)}
            </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ paddingLeft: '16px', paddingRight: '16px' }}>
          <Col className='filler-card-col' flex="auto">
            <FillerCard 
              text={"We take care of your properties coz we value your INVESTMENT"}
            />
          </Col>
          {
            role_name === "Administrator" && (
              <>
                <Col className='top-cards-col' xs={8} sm={8} md={6} lg={3}>
                  <IncomeCard data={dashboardData?.data?.reports}/>
                </Col>
                <Col className='top-cards-col' xs={8} sm={8} md={6} lg={3}>
                  <ExpenseCard data={dashboardData?.data?.reports}/>
                </Col>
                <Col className='top-cards-col' xs={8} sm={8} md={6} lg={3}>
                  <ProfitsCard data={dashboardData?.data?.reports}/>
                </Col>
              </>
            )
          }
          <Col className='top-cards-col' xs={24} sm={24} md={6} lg={3}>
            <ActionsCard 
              title={"Quick Actions"}
              actions={["Add Tenant", "Add Payment", "Add Expense"]}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ padding: '16px' }}>
          <Col xs={24} lg={12}>
            <PropertyCard data={propertyData} rentalUnits={rentalUnits}/>
          </Col>
          <Col xs={24} lg={12}>
            <TenantCard data={dashboardData}/>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ paddingBottom: '16px', paddingLeft: '16px', paddingRight: '16px' }}>
         
          {
            role_name === "Administrator" ? (
              <>
                <Col xs={24} lg={12}>
                  <BillingCard data={dashboardData}/>
                </Col>
                <Col xs={24} lg={12}>
                  <RevenueCard data={revenueData}/>
                </Col>
              </>
            ) : (
              <Col xs={24} lg={24}>
                <BillingCard data={dashboardData}/>
              </Col>
            )
          }
        </Row>
        <Row gutter={[16, 16]} style={{ paddingBottom: '16px', paddingLeft: '16px', paddingRight: '16px' }}>
          <Col xs={24}>
            <MeterCard data={meterData}/>
          </Col>  
        </Row>
      </Layout>
    </Layout>
  );
};

//RENDER DASHBOARD CARD COMPONENTS
//Image card
function FillerCard({ text }) {
  const { Title } = Typography;

  return (
    <Card className="filler-card" style={{ 
      height: '200px',
      borderRadius: '20px',
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      boxShadow: '0px 6px 12px -2px rgba(50, 50, 93, 0.25)'
    }}>
      <Title className='filler-card-text' style={{ 
        color: '#e68941', 
        fontSize: '1.5em', 
        margin: 0,
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        paddingLeft: '60px',
        paddingRight: '200px',
        paddingTop: '65px',
        paddingBottom: '65px',
      }}>{text}</Title>
    </Card>
  );
};

//Total Income card
function IncomeCard({ data }) {
  const { Title, Text } = Typography;
  // const [income, setIncome] = useState(0);
  const navigate = useNavigate()
  // Get current month
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const currentDate = new Date();
  const currentMonth = monthNames[currentDate.getMonth()];

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  // useEffect(() => {
  //   if (data && data?.management_total_income) {
  //     const revenueData = data.management_total_income;
  //     const totalIncome = revenueData.incomes?.reduce((total, income) => {
  //       if (income.month === selectedMonth) {
  //         total += parseFloat(income.total_payment);
  //       }
  //       return total;
  //     }, 0);
  //     setIncome((totalIncome).toLocaleString());
  //   }
  // }, [data, selectedMonth]);

  const handleMonthSelect = ({ key }) => {
    setSelectedMonth(key);
  };

  const monthMenu = (
    <Menu>
      {data && data.data && data.data.revenue && data.data.revenue.incomes && [...new Set(data.data.revenue.incomes.map(item => item.month))].map(month => (
        <Menu.Item key={month} onClick={handleMonthSelect}>{month}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Card className='top-cards cursor' onClick={() => navigate('/management-income')}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
        <Row style={{ marginBottom: '10px' }}>
          <PaymentsOutlined/>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col><Title level={5} className='top-cards-title' style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>Total Income</Title></Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col><Title level={3} className='top-cards-data' style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>{formatAmount(data?.management_total_income)}</Title></Col>
        </Row>
        <Dropdown overlay={monthMenu} placement="bottomCenter" trigger={['click']}>
          <Text 
            style={{ 
              color: 'white', 
              fontSize: '0.8em', 
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease', 
              padding: '2px 5px', 
              borderRadius: '5px',
              ':hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            Month / {selectedMonth}
          </Text>
        </Dropdown>
      </div>
    </Card>
  );
};

//Total Expense card
function ExpenseCard({ data }) {
  const { Title, Text } = Typography;
  // const [expense, setExpense] = useState(0);
  const navigate = useNavigate()

  // Get current month
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const currentDate = new Date();
  const currentMonth = monthNames[currentDate.getMonth()];

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  // useEffect(() => {
  //   if (data && data.data && data.data.revenue && data.data.revenue.expenses) {
  //     const revenueData = data.data.revenue;
  //     const totalExpense = revenueData.expenses?.reduce((total, expense) => {
  //       if (expense.month === selectedMonth) {
  //         total += parseFloat(expense.total_expense);
  //       }
  //       return total;
  //     }, 0);
  //     setExpense((totalExpense).toLocaleString());
  //   }
  // }, [data, selectedMonth]);

  const handleMonthSelect = ({ key }) => {
    setSelectedMonth(key);
  };

  const monthMenu = (
    <Menu>
      {data && data.data && data.data.revenue && data.data.revenue.expenses && [...new Set(data.data.revenue.expenses.map(item => item.month))].map(month => (
        <Menu.Item key={month} onClick={handleMonthSelect}>{month}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Card className='top-cards cursor' onClick={() => navigate('/expense')}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
        <Row style={{ marginBottom: '10px' }}>
          <CreditCardOffOutlined/>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col><Title level={5} className='top-cards-title' style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>Total Expense</Title></Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col><Title level={3} className='top-cards-data' style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>{formatAmount(data?.management_total_expense)}</Title></Col>
        </Row>
        <Dropdown overlay={monthMenu} placement="bottomCenter" trigger={['click']}>
          <Text 
            style={{ 
              color: 'white', 
              fontSize: '0.8em', 
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease', 
              padding: '2px 5px', 
              borderRadius: '5px',
              ':hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            Month / {selectedMonth}
          </Text>
        </Dropdown>
      </div>
    </Card>
  );
};

//Total Profit card
function ProfitsCard({ data }) {
  const { Title, Text } = Typography;
  // const [profit, setProfit] = useState(0);

  // Get current month
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const currentDate = new Date();
  const currentMonth = monthNames[currentDate.getMonth()];

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  // useEffect(() => {
  //   if (data && data.data && data.data.revenue) {
  //     const revenueData = data.data.revenue;
  //     const totalIncome = revenueData.incomes ? revenueData.incomes?.reduce((total, income) => {
  //       if (income.month === selectedMonth) {
  //         total += parseFloat(income.total_payment);
  //       }
  //       return total;
  //     }, 0) : 0;


  //     const totalExpense = revenueData.expenses ? revenueData.expenses.reduce((total, expense) => {

  //       if (expense.month === selectedMonth) {
  //         total += parseFloat(expense.total_expense);
  //       }
  //       return total;

  //     }, 0) : 0;

  //     setProfit((totalIncome - totalExpense).toLocaleString());

  //   }
  // }, [data, selectedMonth]);

  const handleMonthSelect = ({ key }) => {
    setSelectedMonth(key);
  };

  const monthMenu = (
    <Menu>
      {data && data.data && data.data.revenue && data.data.revenue.expenses && [...new Set(data.data.revenue.expenses.map(item => item.month))].map(month => (
        <Menu.Item key={month} onClick={handleMonthSelect}>{month}</Menu.Item>
      ))}
    </Menu>
  );
  return (
    <Card className='top-cards'>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
        <Row style={{ marginBottom: '10px' }}>
          <ShowChart />
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col><Title level={5} className='top-cards-title' style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>Total Profits</Title></Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col><Title level={3} className='top-cards-data' style={{ color: 'white', margin: 0, whiteSpace: 'nowrap' }}>{formatAmount(data?.management_net_pay)}</Title></Col>
        </Row>
        <Dropdown overlay={monthMenu} placement="bottomCenter" trigger={['click']}>
          <Text 
            style={{ 
              color: 'white', 
              fontSize: '0.8em', 
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              padding: '2px 5px',
              borderRadius: '5px',
              ':hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            Month / {selectedMonth}
          </Text>
        </Dropdown>
      </div>
    </Card>
  );
};

//Quick Actions card
function ActionsCard({title, actions}) {
  const {Title} = Typography;
  const navigate = useNavigate()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
    const handleAddTenant = () => {
      navigate('/tenant/add');
    };
    const handleAddExpense = () => {
      navigate('/add-expense');
    };
    const handleTenantPayment = () => {
      navigate('/add-payment/tenant');
    };
    const handleOwnerPayment = () => {
      navigate('/add-payment/owner');
    };
    const handleAddProperty = () => {
      navigate('/property');
    };

    const handleAddRentalUnit = () => {
      navigate('/rental-unit/add');
    };

    const handleAddSupplier = () => {
      navigate('/supplier');
    };

  const paymentMenu = (
    <Menu>
      <Menu.Item key="1" onClick={handleTenantPayment}>
        Tenant Payment
      </Menu.Item>
      <Menu.Item key="2" onClick={handleOwnerPayment}>
        Owner Payment
      </Menu.Item>
    </Menu>
  );

  return (
    <Card className='quick-actions'>
      <Title style={{ fontSize: '1em', marginBottom: '10px', marginTop: '10px', textAlign: 'center' }}>{title}</Title>
      <Row gutter={[16, 16]} justify="center">
        {actions.map((action, index) => (
          <Col key={index}>
            {action === 'Add Payment' ? (
              <Dropdown overlay={paymentMenu} placement="bottomCenter" trigger={['click']}>
                <Button type="primary" className="quick-actions-btn">
                  {action}
                </Button>
              </Dropdown>
            ) : (
              <Button
                type="primary"
                className="quick-actions-btn"
                onClick={() => {
                  switch (action) {
                    case 'Add Tenant':
                      handleAddTenant();
                      break;
                    case 'Add Expense':
                      handleAddExpense();
                      break;
                    default:
                      break;
                  }
                }}
              >
                {action}
              </Button>
            )}
          </Col>
        ))}
        {window.innerWidth <= 767 && (
          <>
            <Col>
              <Button type="primary" className="quick-actions-btn" onClick={handleAddProperty}>
                Add Property
              </Button>
            </Col>
            <Col>
              <Button type="primary" className="quick-actions-btn" onClick={handleAddRentalUnit}>
                Add Rental Unit
              </Button>
            </Col>
            <Col>
              <Button type="primary" className="quick-actions-btn" onClick={handleAddSupplier}>
                Add Supplier
              </Button>
            </Col>
          </>
        )}
      </Row>
    </Card>
  );
};

//Tenant Overview Card
function TenantCard({ data }) {
  const { Title } = Typography;
  const [totalTenants, setTotalTenants] = useState(0);
  const [renewalTenants, setRenewalTenants] = useState(0);
  const [activeTenants, setActiveTenants] = useState(0);
  const [terminatedTenants, setTerminatedTenants] = useState(0);
  const [preterminatedTenants, setPreTerminatedTenants] = useState(0);
  const [moveoutTenants, setMoveOutTenants] = useState(0);
  const navigate = useNavigate()

  useEffect(() => {
    if (data && data.data && data.data.tenants) {
      const tenantData = data.data.tenants; 
      const { 
        total_tenants, 
        for_renewal, 
        active, 
        terminated,
        preterminated,
        move_out,
      } = tenantData;
      setTotalTenants(total_tenants);
      setRenewalTenants(for_renewal);
      setActiveTenants(active);
      setTerminatedTenants(terminated);
      setPreTerminatedTenants(preterminated);
      setMoveOutTenants(move_out);
    }
    else {
      console.warn('Tenant data is missing or in unexpected format');
    }
  }, [data]);

  return (
    <Card style={{ 
      height: '100%', 
      padding: '10px 20px 10px 20px', 
      borderRadius: '20px', 
      boxShadow: '0px 6px 12px -2px rgba(50, 50, 93, 0.25)' 
    }}>
      <Row justify="space-between" style={{ marginBottom: '10px' }}>
        <Col>
          <Title level={3} style={{ fontWeight: 'bold' }}>
            Lease Overview
          </Title>
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
        <Col>Expiring Contracts:</Col>
        <Col className='cursor' onClick={() => navigate('/tenant', { state: "renewal" })} style={{ textAlign: 'right', color: '#37A3F9' }}>
          {renewalTenants}
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
        <Col>Active Contracts:</Col>
        <Col className='cursor' onClick={() => navigate('/tenant', { state: "active" })} style={{ textAlign: 'right', color: '#37A3F9' }}>
          {activeTenants}
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
        <Col>Expired Contracts:</Col>
        <Col className='cursor' onClick={() => navigate('/tenant', { state: "terminated" })} style={{ textAlign: 'right', color: '#37A3F9' }}>
          {terminatedTenants}
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
        <Col>Pre-Terminated Contracts:</Col>
        <Col className='cursor' onClick={() => navigate('/tenant', { state: "terminated" })} style={{ textAlign: 'right', color: '#37A3F9' }}>
          {preterminatedTenants}
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
        <Col>Moved Out:</Col>
        <Col className='cursor' onClick={() => navigate('/tenant', { state: "move_out" })} style={{ textAlign: 'right', color: '#37A3F9' }}>
          {moveoutTenants}
        </Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
        <Col>Total Tenants:</Col>
        <Col className='cursor' onClick={() => navigate('/tenant')} style={{ textAlign: 'right', color: '#37A3F9' }}>
          {totalTenants}
        </Col>
      </Row>
    </Card>
  );
};

//Billing Overview Card
function BillingCard({ data }) {
  const { Title } = Typography;
  const navigate = useNavigate()
  const [openbillTenants, setOpenBillTenants] = useState(0);
  const [duebillTenants, setDueBillTenants] = useState(0);
  const [paymentsForApprovalTenant, setPaymentsForApprovalTenant] = useState(0);
  const [openbillOwners, setOpenBillOwners] = useState(0);
  const [duebillOwners, setDueBillOwners] = useState(0);
  const [paymentsForApprovalOwner, setPaymentsForApprovalOwner] = useState(0);
  
  useEffect(() => {
    if (data && data.data && data.data.billings) {
      const billingData = data.data.billings; 
      const { 
        tenants: { open_bills: tenantOpen, due_bills: tenantDue, payments_for_approval: tenantForApproval },
        owners: { open_bills: ownerOpen, due_bills: ownerDue, payments_for_approval: ownerForApproval }
      } = billingData;
      setOpenBillTenants(tenantOpen);
      setDueBillTenants(tenantDue);
      setPaymentsForApprovalTenant(tenantForApproval);
      setOpenBillOwners(ownerOpen);
      setDueBillOwners(ownerDue);
      setPaymentsForApprovalOwner(ownerForApproval);
    }
    else {
      console.warn('Billing data is missing or in unexpected format');
    }
  }, [data]);

  return (
    <Card style={{ 
      height: '100%', 
      padding: '10px 20px 10px 20px', 
      borderRadius: '20px', 
      boxShadow: '0px 6px 12px -2px rgba(50, 50, 93, 0.25)' 
      }}>
      <Row justify="space-between" style={{ marginBottom: '20px' }}>
        <Col><Title level={3} style={{ fontWeight: 'bold' }}>Billing Overview</Title></Col>
      </Row>
      <Row justify="space-between" style={{ marginBottom: '20px' }}>
        <Col span={11} style={{ paddingRight: '5px' }}>
          <Title level={4} style={{ fontWeight: 'bold' }}>
            Owner
          </Title>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Open Bills:</Col>
            <Col className='cursor' onClick={() => navigate('/owner-billing', { state: "open" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{openbillOwners}</Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Due Bills:</Col>
            <Col className='cursor' onClick={() => navigate('/owner-billing', { state: "due" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{duebillOwners}</Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Payments for Approval:</Col>
            <Col className='cursor' onClick={() => navigate('/owner-billing', { state: "for_approval" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{paymentsForApprovalOwner}</Col>
          </Row>
        </Col>
        <Col span={2}></Col>
        <Col span={11} style={{ paddingLeft: '5px' }}>
          <Title level={4} style={{ fontWeight: 'bold' }}>
            Tenant
          </Title>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Open Bills:</Col>
            <Col className='cursor' onClick={() => navigate('/billing', { state: "open" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{openbillTenants}</Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Due Bills:</Col>
            <Col className='cursor' onClick={() => navigate('/billing', { state: "due" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{duebillTenants}</Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Payments for Approval:</Col>
            <Col className='cursor' onClick={() => navigate('/billing', { state: "for_approval" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{paymentsForApprovalTenant}</Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

// Property Insights card
function PropertyCard({ data, rentalUnits }) {
  const { Title } = Typography;
  const [allUnits, setAllUnits] = useState(0);
  const [occupiedUnits, setOccupiedUnits] = useState(0);
  const [vacantUnits, setVacantUnits] = useState(0); 
  const navigate = useNavigate()

  useEffect(() => {
    if (data && data.data && data.data.rental_units) {
      const rentalData = data.data.rental_units; 
      const { 
        all, 
        occupied, 
        vacant
      } = rentalData;
      setAllUnits(all);
      setOccupiedUnits(occupied);
      setVacantUnits(vacant);
    }
    else {
      console.warn('Rental unit data is missing or in unexpected format');
    }
  }, [data]);

  const pieData = [
    { name: 'Occupied', value: Number(occupiedUnits) },
    { name: 'Vacant', value: Number(vacantUnits) }
  ];
  const COLORS = ['#37A3F9', '#101E3D'];

  const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const rectX = x > cx ? x : x - 29;
    const rectY = y - 10;
    return (
      <g>
        <rect x={rectX} y={rectY} width="32" height="22" fill="rgba(255, 255, 255, 0.5)" rx="5" ry="5" />
        <text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
          <tspan x={x} dy="0em" fontSize="14" fill="#000000">
            {`${(percent * 100).toFixed(0)}%`}
          </tspan>
        </text>
      </g>
    );
  };

  // Generate a unique list of properties
  const getUniqueProperties = () => {
    const properties = rentalUnits?.reduce((acc, unit) => {
      if (!acc.some(property => property.id === unit.property_id)) {
        acc.push({ id: unit.property_id, name: unit.property_name });
      }
      return acc;
    }, []);
    // Add an option for "All Units"
    properties?.unshift({ id: 'All', name: 'All Units' });
    return properties;
  };  

  const handleFilterSelect = async (property_id) => {
    // If 'All Units' is selected, fetch data for all units
    if (property_id === 'All') {
        const response = await UseGetRequest("dashboard/get_property_insights", {});
        if (response && response.data && response.data.data && response.data.data.rental_units) {
            const data = response.data.data.rental_units;
            if (data.all && data.occupied && data.vacant) {
                setAllUnits(data.all);
                setOccupiedUnits(data.occupied);
                setVacantUnits(data.vacant);
            } else {
                // Handle missing data
                console.error('Missing data fields in response');
            }
        } else {
            // Handle unexpected response format
            console.error('Invalid response format or missing data');
        }
    } else {
        // Fetch data for the selected property
        const filteredUnits = rentalUnits.filter(unit => unit.property_id === property_id);
        const all = filteredUnits.length;
        const occupied = filteredUnits.filter(unit => unit.status === 'occupied').length;
        const vacant = filteredUnits.filter(unit => unit.status === 'vacant').length;
        setAllUnits(all);
        setOccupiedUnits(occupied);
        setVacantUnits(vacant);
    }
};  

  // Populate dropdown with unique properties
  const filterMenu = (

    <Menu className="scrollable-dropdown-menu" onClick={(e) => handleFilterSelect(e.key)}>
      {getUniqueProperties()?.map(property => (
        <Menu.Item key={property.id}>{property.name}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Card style={{ 
      height: '100%', 
      padding: '10px 20px 10px 20px', 
      borderRadius: '20px', 
      boxShadow: '0px 6px 12px -2px rgba(50, 50, 93, 0.25)' 
      }}>
      <Row gutter={16} style={{ height: '100%' }}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Row justify="space-between" style={{ marginBottom: '10px' }}>
            <Col>
              <Title level={3} style={{ fontWeight: 'bold' }}>Property Insights</Title></Col>
            <Col>
              <Dropdown overlay={filterMenu} placement="bottomCenter" trigger={"click"}>
                <Button className='filter-button'>FILTER</Button>
              </Dropdown>
            </Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>Total Units:</Col>
            <Col style={{ textAlign: 'right', color: '#37A3F9' }} onClick={() => navigate('/rental-unit')}>{allUnits}</Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>
              <Space>
                <div style={{ width: '10px', height: '10px', backgroundColor: COLORS[0] }}></div>
                Occupied:
              </Space>
            </Col>
            <Col className='cursor' onClick={() => navigate('/rental-unit', { state: "occupied" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{occupiedUnits}</Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
            <Col>
              <Space>
                <div style={{ width: '10px', height: '10px', backgroundColor: COLORS[1] }}></div>
                Vacant:
              </Space>
            </Col>
            <Col  className='cursor' onClick={() => navigate('/rental-unit', { state: "vacant" })} style={{ textAlign: 'right', color: '#37A3F9' }}>{vacantUnits}</Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <PieChart width={180} height={180}>
            <Pie
              dataKey="value"
              startAngle={360}
              endAngle={0}
              data={pieData}
              cx={85}
              cy={85}
              outerRadius={80}
              innerRadius={40}
              fill="#8884d8"
              labelLine={false}
              label={renderLabel} 
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </Col>
      </Row>
    </Card>
  );
};

//Revenue Overview card
function RevenueCard({ data }) {
  const { Title } = Typography;

  // State variables to hold revenue data and filter options
  const [revenueData, setRevenueData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const navigate = useNavigate()

  useEffect(() => {
    if (data && data.data && data.data.revenue) {
      const revenue = data.data.revenue;

      // Ensure expenses and incomes are arrays
      const expenses = revenue.expenses || [];
      const incomes = revenue.incomes || [];

      // Combine expenses and incomes into a single array

      const mergedData = expenses.map(expense => ({

        name: expense.month,
        Expense: parseFloat(expense.total_expense),
        Income: 0,
        year: expense.year
      })).concat(incomes.map(income => ({
        name: income.month,
        Expense: 0,
        Income: parseFloat(income.total_payment),
        year: income.year
      })));

      // Group data by month and year

      const groupedData = mergedData.reduce((acc, obj) => {
        const key = `${obj.year}-${obj.name}`;

        if (!acc[key]) {
          acc[key] = { name: obj.name, Expense: 0, Income: 0, year: obj.year };
        }
        acc[key].Expense += obj.Expense;
        acc[key].Income += obj.Income;
        return acc;
      }, {});

      // Convert object back to array
      if(groupedData){
        const formattedData = Object?.values(groupedData);
        setRevenueData(formattedData);
      }
    }
  }, [data]);

  const handleYearSelect = ({ key }) => {
    setSelectedYear(key);
    setSelectedMonth(null); // Reset selected month when year changes
  };

  // const handleMonthSelect = ({ key }) => {
  //   setSelectedMonth(key);
  //   setSelectedYear(null); // Reset selected year when month changes
  // };

  const filterMenu = (
    <Menu>
      <Menu.SubMenu title="Select Year">
        {[...new Set(revenueData.map(item => item.year))].map(year => (
          <Menu.Item key={year} onClick={handleYearSelect}>{year}</Menu.Item>
        ))}
      </Menu.SubMenu>
      {/* <Menu.SubMenu title="Select Month">
        {[...new Set(revenueData.map(item => item.name))].map(month => (
          <Menu.Item key={month} onClick={handleMonthSelect}>{month}</Menu.Item>
        ))}
      </Menu.SubMenu> */}
    </Menu>
  );

  // Filter data based on selected year and month
  const filteredData = revenueData.filter(item => {
    let yearCondition = true;
    let monthCondition = true;

    if (selectedYear) {
      yearCondition = item.year === selectedYear;
    }

    if (selectedMonth) {
      monthCondition = item.name === selectedMonth;
    }

    return yearCondition && monthCondition;
  });

  const handleBarClick = (data, index) => {
    // setSelectedMonth(data.name);
    // You can perform any action here when a bar is clicked
  };

  return (
    <Card style={{ 
      height: '100%', 
      borderRadius: '20px', 
      boxShadow: '0px 6px 12px -2px rgba(50, 50, 93, 0.25)' 
    }}>
      <Row justify="space-between" align="middle" style={{ padding: '0px 20px 0px 20px' }}>
        <Col><Title level={3} style={{ fontWeight: 'bold' }}>Revenue Overview</Title></Col>
        <Col>
          <Row align="middle" gutter={10}>
            <Col>
              <Row align="middle" gutter={5} onClick={() => navigate('/management-income')}>
                <Col><div style={{ width: '10px', height: '10px', backgroundColor: '#37A3F9' }}></div></Col>
                <Col><span>Income</span></Col>
              </Row>
            </Col>
            <Col>
              <Row align="middle" gutter={5} onClick={() => navigate('/management-income')}>
                <Col><div style={{ width: '10px', height: '10px', backgroundColor: '#101E3D' }}></div></Col>
                <Col><span>Expense</span></Col>
              </Row>
            </Col>
            <Col>
              <Dropdown overlay={filterMenu} placement="bottomCenter" trigger={"click"}>
                <Button className='filter-button'>FILTER</Button>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Row>
      <div style={{ width: '100%', height: '180px', overflowX: 'auto' }}>
        <ResponsiveContainer width="100%" height={180}>
          <BarChart
            width={530}
            height={180} 
            data={filteredData}
            margin={{
              top: 5, right: 10, left: -5, bottom: -25,
            }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" interval={0} angle={-45} textAnchor="end" height={60} />
            {/* <YAxis ticks={[50000, 100000, 150000, 200000, 250000, 300000, 350000]} /> */}
            <YAxis />
            <Tooltip />
            <Bar dataKey="Income" fill="#37A3F9" onClick={(e) => handleBarClick(e)}  />
            <Bar dataKey="Expense" fill="#101E3D" onClick={(e) => handleBarClick(e)}  />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

// Meter Readings card
function MeterCard({ data }) { // data prop contains the meter readings data
  const { Title } = Typography;
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const navigate = useNavigate()

  const handleYearSelect = ({ key }) => {
    setSelectedYear(key);
  };

  const handleMonthSelect = ({ key }) => {
    setSelectedMonth(key);
  };

  const combinedData = data && data.data && data.data.meter_readings 
    ? Object.keys(data.data.meter_readings)?.reduce((acc, key) => {
        if (data.data.meter_readings[key]) { // Check if meter_readings[key] is not null
          data.data.meter_readings[key].forEach(item => {
            if (item && item.total_consumption) { // Check if item and total_consumption are not null
              const existingItem = acc.find(i => i.name === item.month && i.year === item.year);
              if (existingItem) {
                existingItem[key] = parseFloat(item.total_consumption);
              } else {
                acc.push({
                  name: item.month,
                  year: item.year,
                  [key]: parseFloat(item.total_consumption),
                });
              }
            }
          });
        }
        return acc;
      }, [])
    : [];

  const filterMenu = (
    <Menu>
      <Menu.SubMenu title="Select Year">
        {combinedData.length > 0 && [...new Set(combinedData.map(item => item.year))].map(year => (
          <Menu.Item key={year} onClick={handleYearSelect}>{year}</Menu.Item>
        ))}
      </Menu.SubMenu>
      <Menu.SubMenu title="Select Month">
        {combinedData.length > 0 && [...new Set(combinedData.map(item => item.name))].map(month => (
          <Menu.Item key={month} onClick={handleMonthSelect}>{month}</Menu.Item>
        ))}
      </Menu.SubMenu>
    </Menu>
  );

  // Filter data based on selected year and month
  const filteredData = combinedData.filter(item => {
    let yearCondition = true;
    let monthCondition = true;

    if (selectedYear) {
      yearCondition = item.year === selectedYear;
    }

    if (selectedMonth) {
      monthCondition = item.name === selectedMonth;
    }

    return yearCondition && monthCondition;
  });

  return (
    <Card style={{ 
      height: '100%', 
      padding: '10px 0px 10px 0px', 
      borderRadius: '20px', 
      boxShadow: '0px 6px 12px -2px rgba(50, 50, 93, 0.25)' 
      }}>
      <Row gutter={16} style={{ height: '100%' }}>
        <Col xs={24} sm={24} md={12} lg={12} style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
            <ResponsiveContainer width="100%" height={180}>
              <LineChart
                data={filteredData}
                margin={{ top: 5, right: 10, left: -10, bottom: -10 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" interval={0} angle={-45} textAnchor="end" height={60} />
                <YAxis ticks={[50, 100, 150, 200, 250, 300]}/>
                <Tooltip/>
                <Line type="monotone" dataKey="electricity" stroke="#FFBB28" activeDot={{ r: 8 }}/>
                <Line type="monotone" dataKey="water" stroke="#0088FE"/>
                <Line type="monotone" dataKey="gas" stroke="#00C49F"/>
              </LineChart>
            </ResponsiveContainer>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} style={{ padding: '0px 40px 0px 40px' }}>
          <Row justify="space-between" style={{ marginBottom: '10px' }}>
            <Col><Title level={3} style={{ fontWeight: 'bold' }}>Meter Readings</Title></Col>
            <Col><Dropdown overlay={filterMenu} placement="bottomCenter" trigger={"click"}>
                <Button className='filter-button'>FILTER</Button>
              </Dropdown>
            </Col>
          </Row>
          <Row className='cursor' onClick={() => navigate('/electric-reading')} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontWeight: 'bold' }}>
            <div style={{ width: '10px', height: '10px', backgroundColor: '#FFBB28', marginRight: '5px' }}></div>
            <span>Electricity Consumption</span>
          </Row>
          <Row className='cursor' onClick={() => navigate('/water-reading')} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontWeight: 'bold' }}>
            <div style={{ width: '10px', height: '10px', backgroundColor: '#0088FE', marginRight: '5px' }}></div>
            <span>Water Consumption</span>
          </Row>
          <Row className='cursor' onClick={() => navigate('/gas-reading')} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontWeight: 'bold' }}>
            <div style={{ width: '10px', height: '10px', backgroundColor: '#00C49F', marginRight: '5px' }}></div>
            <span>Gas Consumption</span>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default Dashboard;